import { render, staticRenderFns } from "./contentDetailCardSlider.vue?vue&type=template&id=30fd561c&scoped=true"
import script from "./contentDetailCardSlider.vue?vue&type=script&lang=js"
export * from "./contentDetailCardSlider.vue?vue&type=script&lang=js"
import style0 from "./contentDetailCardSlider.vue?vue&type=style&index=0&id=30fd561c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fd561c",
  null
  
)

export default component.exports